/**
 * @desc 条件查询周曲线
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.DiagramQueryRequest,
): Promise<defs.StandardReturn<defs.DiagramQueryResponse>> {
  return defHttp.post({
    url: '/web/diagram/query',
    data,
  });
}

export function mock(
  data: defs.DiagramQueryRequest,
): Promise<defs.StandardReturn<defs.DiagramQueryResponse>> {
  return defHttp.post({
    url: '/mock/web/diagram/query',
    data,
  });
}
